<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <router-link :to="`/fzorganhistory/${activeName}/${pageIndex}`">
                        <i class="el-icon-arrow-left" style="cursor: pointer;"></i>
                        牌照审核中
                    </router-link>/ 牌照审核详情
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="purchasesee-box">
            <p class="purchasesee-title">车主及业务员信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item1">
                    <li>
                        车主:
                        <span>{{seelicenseApplylist.ownerName}}</span>
                    </li>
                    <li>
                        手机号:
                        <span>{{seelicenseApplylist.ownerCellphoneNumber}}</span>
                    </li>
                    <li>
                        办理业务员:
                        <span>{{seelicenseApplylist.applicantName}}</span>
                    </li>
                </ul>
                <ul class="seelicense-item1">
                    <li>
                        地区:
                        <span>{{seelicenseApplylist.provinceName}}{{seelicenseApplylist.cityName}}</span>
                    </li>
                    <li>
                        身份证号:
                        <span>{{seelicenseApplylist.ownerIdentityCards}}</span>
                    </li>
                </ul>
                <ul class="seelicense-itemphoto" v-if="seelicenseApplylist.ownerIdentityCardsPhoto">
                    <li>身份证照片:</li>
                    <li v-for="item in seelicenseApplylist.ownerIdentityCardsPhoto">
                        <img :src="'/api/static'+item" alt />
                    </li>
                </ul>
            </div>

            <p class="purchasesee-title" style="border-left: none;"></p>

            <p class="purchasesee-title">基本信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item3">
                    <li>
                        设备编号:
                        <span>{{seelicenseApplylist.equipmentCode}}</span>
                    </li>
                </ul>
                <ul class="seelicense-item3">
                    <li>
                        环保编码：
                        <span>{{seelicenseApplylist.environmentalProtectionNumber}}</span>
                    </li>
                    <li>
                        排放登记:
                        <span>{{seelicenseApplylist.emissionRegistration}}</span>
                    </li>
                </ul>
                <ul class="seelicense-item3">
                    <li>发动机功率：{{seelicenseApplylist.enginePower}}</li>
                    <li>
                        机械品牌:
                        <span>{{seelicenseApplylist.machineryBrand}}</span>
                    </li>
                </ul>
                <ul class="seelicense-item3">
                    <li>
                        机械颜色：
                        <span>{{seelicenseApplylist.machineryColor}}</span>
                    </li>
                    <li>
                        机械类型:
                        <span>{{seelicenseApplylist.machineryType}}</span>
                    </li>
                </ul>
                <ul class="seelicense-item3">
                    <li>
                        生产国别：
                        <span>{{seelicenseApplylist.productionCountry}}</span>
                    </li>
                    <li>
                        整机架号:
                        <span>{{seelicenseApplylist.frameNo}}</span>
                    </li>
                </ul>
                <ul class="seelicense-item3">
                    <li>
                        燃油类型：
                        <span>{{seelicenseApplylist.fuelType}}</span>
                    </li>
                    <li>
                        发动机号:
                        <span>{{seelicenseApplylist.engineNumber}}</span>
                    </li>
                </ul>
                <ul class="seelicense-item3">
                    <li>
                        整机质量：
                        <span>{{seelicenseApplylist.overallQuality}}</span>
                    </li>
                    <li>
                        出厂日期:
                        <span>{{seelicenseApplylist.productionDateStr}}</span>
                    </li>
                </ul>
                <ul class="seelicense-item3">
                    <li>
                        核载质量：
                        <span>{{seelicenseApplylist.nuclearInformation}}</span>
                    </li>
                    <li>
                        生产厂家：
                        <span>{{seelicenseApplylist.factory}}</span>
                    </li>
                </ul>
                <ul class="seelicense-itemphoto" v-if="seelicenseApplylist.mechanicalPictures">
                    <li>机械图片:</li>
                    <li v-for="item in seelicenseApplylist.mechanicalPictures">
                        <img :src="'/api/static'+item" alt />
                    </li>
                </ul>
            </div>
            <p class="purchasesee-title">邮寄地址</p>
            <div class="purchasesee-padding">
                <p class="seelicense-item5">
                    收货人姓名:
                    <span>{{seelicenseApplylist.shippingName}}</span>
                </p>
                <p class="seelicense-item5">
                    收货人手机号:
                    <span>{{seelicenseApplylist.shippingCellphoneNumber}}</span>
                </p>
                <p class="seelicense-item5">
                    收货地址:
                    <span>{{seelicenseApplylist.shippingAddress}}</span>
                </p>
            </div>
            <p class="purchasesee-title">易车信息</p>
            <div class="purchasesee-padding">
                <div class="purchasesee-padding">
                    <ul
                        class="seelicense-item4"
                        v-if="seelicenseApplylist.receiverName || seelicenseApplylist.receiverCellphoneNumber || seelicenseApplylist.receiverIdentityCards"
                    >
                        <li
                            v-if="seelicenseApplylist.receiverName || seelicenseApplylist.receiverCellphoneNumber || seelicenseApplylist.receiverIdentityCards"
                        >车主变更</li>
                        <li
                            v-if="seelicenseApplylist.receiverName"
                        >接收人:{{seelicenseApplylist.receiverName}}</li>
                        <li
                            v-if="seelicenseApplylist.receiverCellphoneNumber"
                        >接收人电话: {{seelicenseApplylist.receiverCellphoneNumber}}</li>
                        <li
                            v-if="seelicenseApplylist.receiverIdentityCards"
                        >接收人证件号: {{seelicenseApplylist.receiverIdentityCards}}</li>
                    </ul>
                    <p class="seelicense-item2" v-else>无</p>
                </div>
            </div>
        </div>
        <p class="purchasesee-text2" style="margin-top: 30px;">
            <el-button type="primary" class="handle-del mr10">
                <router-link :to="'/examine/'+licenseApplyId" style="color: #fff;">信息修改</router-link>
            </el-button>
        </p>

        <!-- <p style="margin-top: 20px;">
            <el-button type="primary" @click="passseeApply()">通过</el-button>
            <el-button type="primary" @click="fallbackapplyfirst('fallbackform')">退回</el-button>
        </p>

        <el-dialog class="branch-dialog" title="退回原因" :visible.sync="fallbackVisible" width="600px">
            <el-form ref="fallbackform" :model="fallbackform">
                <el-form-item label prop="auditReason">
                    <el-input
                        type="textarea"
                        v-model="fallbackform.auditReason"
                        placeholder="请输入回退原因"
                        class="resizeNone"
                    ></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="savefallbackfirst()">确 定</el-button>
                <el-button @click="fallbackVisible = false">取 消</el-button>
            </span>
        </el-dialog>-->
    </div>
</template>

<script>
import {getLicenseApplyExamine,examineLicenseApply} from '@/api/index';
export default {
	
    name: 'seelicensecheckfzbfirst',
    data() {
        return {
			licenseApplyId:'',
			activeName:'',
			pageIndex:'',
			seelicenseApplylist:{},//查看
			fallbackVisible:false,
			fallbackform:{
				auditReason:''
			},
			licenseArrId:[]
        };
    },
    created() {
		this.licenseApplyId = this.$route.params.licenseApplyId;
		this.activeName = this.$route.params.activeName;
		this.pageIndex = this.$route.params.pageIndex;
		this.licenseArrId.push(this.$route.params.licenseApplyId);
		// 查看
		getLicenseApplyExamine({
			"licenseApplyId": this.licenseApplyId
		}).then(res => {
			console.log(res.data)
			this.seelicenseApplylist = res.data;
			if(res.data.ownerIdentityCardsPhoto){
				this.seelicenseApplylist.ownerIdentityCardsPhoto = res.data.ownerIdentityCardsPhoto.split(',');
			}
			if(res.data.mechanicalPictures){
				this.seelicenseApplylist.mechanicalPictures = res.data.mechanicalPictures.split(',');
			}
			
		});
    },
    methods: {
	// 通过
	  passseeApply(){
		this.$confirm('确定要通过吗？', '提示', {
		    type: 'warning'
		}).then(() => {
		        examineLicenseApply({
		        	isPass:1,                    
		        	licenseApplyIds: this.licenseArrId              
		        }).then(res => {
		        	if(res.code == 0){
		        		// 获取数据成功后的其他操作
		        		this.$message({
		        		  message: res.message,
		        		  type: 'success'
		        		});
		        		this.$router.push('/licensecheckzbperson');
						// listTaskRemindNum({}).then(ress => {
						// 	   this.$store.state.totalNum =  ress.data.totalNum;
						// });
		        	}else {
		        		this.$message({
		        		  message: res.message,
		        		  type: 'error'
		        		});
		        	}
		        	
		        });
		}).catch(() => {});
		
		
		
	  },
	  // 回退弹框
	  fallbackapplyfirst(formName){
	  	
	  	this.fallbackVisible = true;
	  	//重置表单数据
	  	this.$nextTick(()=>{
	  	  this.$refs.[formName].resetFields();
	  	})
	  	
	  	
	  },
	  
	  //审核退回
	  savefallbackfirst(){
	  	this.$confirm('确定要退回吗？', '提示', {
	  	    type: 'warning'
	  	}).then(() => {
	  	        examineLicenseApply({
	  				auditReason:this.fallbackform.auditReason,
	  	        	isPass:2,                    
	  	        	licenseApplyIds: this.licenseArrId               
	  	        }).then(res => {
	  						if(res.code == 0){
	  							// 获取数据成功后的其他操作
	  							this.$message({
	  							  message: res.message,
	  							  type: 'success'
	  							});
	  							this.fallbackVisible = false;
	  							this.$router.push('/licensecheckzbperson');
								// listTaskRemindNum({}).then(ress => {
								// 	   this.$store.state.totalNum =  ress.data.totalNum;
								// });
	  						}else {
	  							this.$message({
	  							  message: res.message,
	  							  type: 'error'
	  							});
	  						}
	  	        });
	  	}).catch(() => {});
	  },
    }
};
</script>

<style scoped>
.purchasesee-box {
    background: #fff;
    padding: 20px 0;
}
.purchasesee-title {
    height: 30px;
    line-height: 30px;
    background: #f0f0f0;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2px;
    border-left: 5px solid #437af4;
    text-indent: 30px;
}
.purchasesee-padding {
    padding: 20px 0;
}
.seelicense-item1 {
    display: flex;
    display: -webkit-flex;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 20px;
}
.seelicense-item1 li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-item1 li:last-child {
    flex: 1;
}
.seelicense-itemphoto {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    list-style: none;
    padding-left: 35px;
    color: #666;
}
.seelicense-itemphoto li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-itemphoto li:first-child {
    width: 100px;
}
.seelicense-itemphoto li img {
    width: 100%;
}
.seelicense-item2 {
    padding: 0 35px;
    margin-top: 15px;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item3 {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 10px;
}
.seelicense-item3 li {
    width: 350px;
}
.seelicense-item4 {
    margin: 0 35px;
    background: #f8f8fb;
    padding: 20px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item4 li {
    margin-bottom: 10px;
}
.seelicense-item5 {
    padding-left: 35px;
    height: 32px;
    line-height: 32px;
    letter-spacing: 1px;
    color: #666;
}
.purchasesee-text1,
.purchasesee-text2 {
    height: 32px;
    line-height: 32px;
    text-indent: 15px;
}

.purchasesee-text2 {
    text-indent: 50px;
}
.purchasesee-table {
    width: 50%;
    margin: 10px 0 30px 50px;
}
.purchasesee-linceinfo {
    margin: 10px 50px;
    display: flex;
    display: -webkit-flex;
}
.purchasesee-linceitem {
    width: 30%;
}
.purchasesee-linceitem:nth-child(2) {
    margin: 0 3%;
}

.organ-box {
    margin-bottom: 20px;
    text-align: right;
}
.apply-box {
    display: flex;
    display: -webkit-flex;
}
.apply-box p {
    flex: 1;
}

.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
